import styled, { css } from 'styled-components';
import ContentCard from '@mlb/react-patterns/components/ContentCard/contentCard';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton';
import { TitleWrapper, ImageWrapper, ContentWrapper, DataWrapper } from '@mlb/react-patterns/components/ContentCard/contentCard.style';
import { VideoThumbnailWrapper, VideoPlayerWrapper, HighlightGradient } from '../VideoPlayer/VideoPlayer.style';
import { ShareWrapper } from '../Share/share.style';

const TextOverflowWrapper = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

/* Video Player & Headline Styles */

export const HeadlineTitleWrapper = styled(TextOverflowWrapper)`
    width: calc(100% - 38px);
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
`;

export const HighlightVideoHeadlineWrapper = styled.div`
    height: 126px;
    padding: 16px;
    display: flex;
    box-sizing:border-box;
    position:relative;
    flex-direction: column;
    row-gap: 4px;
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);

    ${ShareWrapper} {
        position: absolute;
        top: 7px;
        right: 12px;
    }
`;

export const HeadlineDescriptionWrapper = styled(TextOverflowWrapper)`
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
`;

export const HighlightVideoPlayerWrapper = styled.div`
    flex-shrink: 0;
    border-bottom: 1px solid var(--gameday-divider-color);
    ${HighlightGradient},
    ${VideoPlayerWrapper},
    ${VideoThumbnailWrapper},
    img,
    video,
    .media-player,
    .mlb-player-controls,
    .media-controls,
    .bottom-controls-container
    {
        border-radius: 0px !important;
    }
    .leave-behind-overlay {
        img{
            opacity: 0.6 !important;
        }
        h1 {
            font-size: 20px;
        }
        p {
            font-size: 14px;
        }
        .play-button {
            display: block !important;
        }
    }
`;

/* Structure & Container Styles */

export const HighlightCardListSkeletonWrapper = styled.div`
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const HighlightCardListWrapper = styled.div`
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    overflow-y: auto;
`;

export const HighlightPlaylistWrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-color: var(--gameday-background-color);
    display: flex;
    flex-direction: column;

    ${({ $extendedDisplay }) => $extendedDisplay && css`
        @media only screen and (max-height: 1024px) {
            flex-direction: row;
            ${HighlightVideoPlayerWrapper} {
                width: 50%;
                display: flex;
                flex-direction: column;
                overflow-y: auto;
                border-bottom: none;
                border-right: 1px solid var(--gameday-divider-color);
                ${VideoPlayerWrapper} {
                    overflow: visible;
                }
            }
            ${HighlightCardListWrapper} {
                width: 100%;
                padding-top: 16px;
            }
            ${HeadlineTitleWrapper} {
                font-size: 18px;
                line-height: 27px;
                -webkit-line-clamp: unset;
            }
            ${HeadlineDescriptionWrapper} {
                font-size: 16px;
                line-height: 24px;
                -webkit-line-clamp: unset;
            }
            ${HighlightVideoHeadlineWrapper} {
                height: auto;
                row-gap: 8px;
            }
        }
    `}
`;

/* Card Styles */
export const ContentCardWrapper = styled(ContentCard)`
    cursor: pointer;
    border-radius: var(--gameday-border-radius);

    ${ContentWrapper} {
        padding-top: 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
    }
    ${DataWrapper} {
        position: unset;
    }
    ${TitleWrapper} {
        font-size: 14px;
        line-height: 14px;
        font-weight: unset;
        color: var(--gameday-primary-font-color);
    }
    &:hover ${TitleWrapper} {
        color: var(--gameday-link-color)
    }
    ${({ isActive }) => isActive && css`
        ${ImageWrapper} {
            ::after {
                background: rgba(0, 0, 0, 0.75);
                border: none;
                font-size: 14px;
            }
        }
    `}
`;

export const ContentCardSubtitleWrapper = styled.div`
    color: var(--gameday-secondary-font-color);
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
`;

export const UpNextWrapper = styled(ContentCardSubtitleWrapper)`
    position: absolute;
    top: 0;
    font-weight: 700;
`;

export const ContentCardTitleWrapper = styled(TextOverflowWrapper)`
    font-family: var(--gameday-primary-font);
    font-weight: 700;
`;

export const HeadlineWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    gap: 4px;
`;

/* Empty State Styles */
export const EmptyPlaylistWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 0;
`;

export const EmptyTextWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    font-size: 18px;
    padding-top: 16px;
    color: var(--gameday-primary-font-color);
`;

export const HighlightVideoPlayerSkeleton = styled(Skeleton)`
    aspect-ratio: 16/9;
`;
